import {
  ArrowRightCircleIcon,
  ArrowUturnDownIcon,
  ArrowUturnLeftIcon,
  HomeModernIcon,
  InformationCircleIcon,
  MagnifyingGlassIcon,
} from '@heroicons/react/24/outline';
import { BellAlertIcon, EyeIcon, PencilIcon, TrashIcon, UserMinusIcon, UserPlusIcon } from '@heroicons/react/24/solid';
import {
  Card,
  CardHeader,
  Input,
  Typography,
  Button,
  CardBody,
  Chip,
  CardFooter,
  Tabs,
  TabsHeader,
  Tab,
  Avatar,
  IconButton,
  Tooltip,
  Checkbox,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Alert,
} from '@material-tailwind/react';

import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listUserIDAll, listUserIDAllCount, updateUserID } from '../../../services/apiUsers';
import {
  listProductIDAll,
  listProductIDAllCount,
  listProductIDAllCountUser,
  listProductIDAllUser,
  updateBds,
  uploadFileSim,
} from '../../../services/apiBds';
import { decode, encode, getCookie, numberFormatTextShorten } from '../../../utils/helper';
import { isAdmin } from '../../../utils/permissions';
import { API_URL } from '../../../utils/urls';

const TABLE_HEAD = ['Mã SP', 'Tiêu đề', 'Trạng thái', 'Ngày tạo', 'Tác vụ'];

const TABS = [
  {
    label: 'Tin Đã Duyệt',
    value: '',
  },
  {
    label: 'Chờ Duyệt của bạn',
    value: 3,
  },
];

export default function DsBds() {
  const auth = getCookie('token');
  const [resultListBds, setResultListBds] = useState([]);
  const [page, setPage] = useState(1);
  const [countChoDuyet, setCountChoDuyet] = useState('');
  const [countBds, setCountBds] = useState(0);
  const [countBdsAll, setCountBdsAll] = useState(0);
  const [objBoLoc, setObjBoLoc] = useState({ stt: '', username: auth?.username, code: '' });
  const [openDetail, setOpenDetail] = useState(false);
  const [objDetailBds, setObjDetailBds] = useState(false);
  const [message, setMessage] = useState('');
  const [isStatus, setIsStatus] = useState('');

  const handleOpen = () => setOpenDetail(!openDetail);

  const listUserAll = async (pages = 1, stt = '', username = '', code = '') => {
    setIsStatus(stt);
    const resultBDSAll = await (username === 'admin'
      ? listProductIDAll(pages, stt, code)
      : listProductIDAllUser(pages, stt, username, code));
    if (resultBDSAll.length > 0) {
      setResultListBds(resultBDSAll);
      const countBds = await (username === 'admin'
        ? listProductIDAllCount(stt, code)
        : listProductIDAllCountUser(stt, username, code));
      setCountBds(countBds.totalRows);
    } else {
      setResultListBds([]);
      setCountBds(0);
    }
  };

  const listTinChoDuyet = async () => {
    const countBds = await (auth?.username === 'admin'
      ? listProductIDAllCount(3)
      : listProductIDAllCountUser(3, auth?.username));
    setCountChoDuyet(countBds.totalRows);
  };

  useEffect(() => {
    listUserAll(1, '', auth?.username);
    listTinChoDuyet();
    // listTinChoDuyetAll();
    document.title = 'Danh sách nhân viên';
  }, []);

  const listTinChoDuyetAll = async () => {
    const countBds = await listProductIDAllCount(3);
    setCountBdsAll(countBds.totalRows);
  };

  const listChoDuyetAll = async (pages = 1, stt = '', code = '') => {
    setIsStatus(4);
    const resultBDSAll = await listProductIDAll(pages, stt, code);
    if (resultBDSAll.length > 0) {
      setResultListBds(resultBDSAll);
      const countBds = await listProductIDAllCount(stt, code);
      setCountBdsAll(countBds.totalRows);
    } else {
      setResultListBds([]);
    }
  };

  const isPostExpired = (createDate) => {
    const parts = createDate.split('T');
    const dateParts = parts[0].split('/');
    const formattedDate = `${dateParts[2]}-${dateParts[1].padStart(2, '0')}-${dateParts[0].padStart(2, '0')}T${
      parts[1]
    }`;

    const postTime = new Date(formattedDate).getTime();
    if (isNaN(postTime)) return false; // Kiểm tra lỗi parse

    const currentTime = new Date().getTime();
    const diffMinutes = (currentTime - postTime) / (1000 * 60);
    return diffMinutes > 30;
  };

  const handleEnterKey = (e) => {
    if (e.key === 'Enter') {
      listUserAll(1, objBoLoc.stt, objBoLoc.username, decode(objBoLoc.code));
    }
  };

  const nextPage = () => {
    const total = Math.ceil(countBds / 50);
    if (total > page) {
      setPage(page + 1);
      listUserAll(page + 1, objBoLoc.stt, objBoLoc.username, decode(objBoLoc.code));
    }
  };

  const prevPage = () => {
    const total = Math.ceil(countBds / 50);
    if (total <= page && page > 1) {
      setPage(page - 1);
      listUserAll(page - 1, objBoLoc.stt, objBoLoc.username, decode(objBoLoc.code));
    }
  };

  const alertRemoveUser = async (id, status) => {
    if (window.confirm(status === '1' ? `Bạn đã chắc chắn ĐÃ BÁN` : `Bạn muốn cho TIN HOẠT ĐỘNG chở lại`)) {
      // Save it!
      const formData = new FormData();
      const body = { id: id, status: status === '1' ? '2' : '1' };
      formData.append('data', JSON.stringify(body));
      //   formData.append('imgremove', JSON.stringify([]));
      const resultAPISIM = await updateBds(formData);
      if (resultAPISIM?.message === 'OK') {
        listUserAll(page, objBoLoc.stt, objBoLoc.username, decode(objBoLoc.code));
      }
    } else {
      // Do nothing!
      console.log('Hủy yêu cầu');
    }
  };

  const alertRemoveBV = async (id) => {
    if (window.confirm(`Bạn muốn cho tin này vào THÙNG RÁC`)) {
      // Save it!
      const formData = new FormData();
      const body = { id: id, status: '4' };
      formData.append('data', JSON.stringify(body));
      const resultAPISIM = await updateBds(formData);
      if (resultAPISIM?.message === 'OK') {
        listUserAll(page, objBoLoc.stt, objBoLoc.username, decode(objBoLoc.code));
      }
    } else {
      // Do nothing!
      console.log('Hủy yêu cầu');
    }
  };
  const alertNORemoveBV = async (id) => {
    if (window.confirm(`Bạn muốn hoàn lại tin`)) {
      // Save it!
      const formData = new FormData();
      const body = { id: id, status: '1' };
      formData.append('data', JSON.stringify(body));
      const resultAPISIM = await updateBds(formData);
      if (resultAPISIM?.message === 'OK') {
        listUserAll(page, objBoLoc.stt, objBoLoc.username, decode(objBoLoc.code));
      }
    } else {
      // Do nothing!
      console.log('Hủy yêu cầu');
    }
  };

  const typeImg = (str) => {
    const lastIndex = str.lastIndexOf('.');
    const result = str.substring(lastIndex + 1);
    if (result === 'png' || result === 'jpg' || result === 'jpeg') {
      return true;
    } else {
      return false;
    }
  };

  const handleFileUpload = async (e) => {
    setMessage('Loading');
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    formData.append('username', auth?.username);
    formData.append('id_user', auth?.id);
    // formData.append('domain', hostname);
    const resultAPISIM = await uploadFileSim(formData);
    if (resultAPISIM['message'] === 'Ok') {
      listUserAll(1, '', auth?.username);
      setMessage('Thành Công');
      setTimeout(() => {
        setMessage('');
      }, 3000);
    }
  };

  return (
    <div>
      <Dialog open={openDetail} handler={handleOpen}>
        <DialogHeader className="font-[UTM-Avo]">{objDetailBds?.tieude ? objDetailBds?.tieude : ''}</DialogHeader>
        <DialogBody className="h-[42rem] overflow-scroll leading-8 font-[500]">
          <div className="text-gray-900 font-[UTM-Avo] ">
            <p>
              <b>Ngày tạo bài</b>: <b className="text-green-500">{objDetailBds?.create_date}</b>
            </p>
            <p>
              <b>Số nhà</b>: {objDetailBds?.sonha}
            </p>
            <p>
              <b>Đường</b>: {objDetailBds?.duong}
              <b className="ml-2">Phường/xã</b>: {objDetailBds?.xa}
              <b className="ml-2">Quận/huyện</b>: {objDetailBds?.huyen}
              <b className="ml-2">Tỉnh</b>: {objDetailBds?.tinh}
            </p>
            <p>
              <b>Khu quy hoạch</b>: {objDetailBds?.khuqh}
            </p>
            <p>
              <b>Số tờ/Số thửa</b>:{' '}
              {objDetailBds?.soto?.split(',').length > 0 &&
                objDetailBds?.soto
                  ?.split(',')
                  .map((row, i) => (
                    <p key={i}>{`- ${row}/${
                      objDetailBds?.sothua?.split(',').length > 0 ? objDetailBds?.sothua?.split(',')[i] : ''
                    }`}</p>
                  ))}
            </p>
            <p>
              <b>Số chủ đất</b>:{' '}
              {objDetailBds?.sdtchudat?.split(',').length > 0 && isPostExpired(objDetailBds?.create_date) ? (
                objDetailBds?.sdtchudat?.split(',').map((row, i) => <p key={i}>{`- ${row}`}</p>)
              ) : (
                <b className="text-red-500">Hệ thống sẽ hiển thị sau 30 phút kể từ lúc tạo bài viết</b>
              )}
            </p>
            <p>
              <b>Bán - Cho Thuê: </b>
              <p>{objDetailBds?.isbandat === 1 && '- Bán'}</p>
              <p>{objDetailBds?.ischothue === 1 && ' - Cho thuê'}</p>
            </p>
            <p>
              <b>Rộng đường trước nhà: </b> {objDetailBds?.rongduong} m
            </p>
            <p>
              <b>Quy hoạch: </b> {objDetailBds?.quyhoach}
            </p>
            <p>
              <b>Pháp lý: </b> {objDetailBds?.phaply}
            </p>
            <p>
              <b>Hướng: </b> {objDetailBds?.huongbds}
            </p>
            <p>
              <b>Loại vị trí: </b> {objDetailBds?.loaivitri}
            </p>
            <p>
              <b>Loại bđs: </b> {objDetailBds?.loaibds}
            </p>
            <p>
              <b>Tiện Nghi & Kết Cấu: </b> {objDetailBds?.tiennghi}
            </p>
            <p>
              <b>Đặc trưng: </b> {objDetailBds?.dactrung}
            </p>
            <p>
              <b>Ghi chú khách: </b> {objDetailBds?.notekhach}
            </p>
            <p>
              <b>Ghi chú nội bộ: </b> {objDetailBds?.notenoibo}
            </p>
            <p>
              <b>Diện tích đất ở: </b> {objDetailBds?.dientich} m2
            </p>
            <p>
              <b>DT đất nông nghiệp: </b> {objDetailBds?.dientichdatnn} m2
            </p>
            <p>
              <b>Tổng DT sàn (các tầng): </b> {objDetailBds?.dientichsan} m2
            </p>
            <p>
              <b>Ngang: </b> {objDetailBds?.ngang} m
            </p>
            <p>
              <b>Ngang hậu: </b> {objDetailBds?.nganghau} m
            </p>
            <p>
              <b>Dài: </b> {objDetailBds?.dai} m
            </p>
            <p>
              <b>Số tầng: </b> {objDetailBds?.sotang} tầng
            </p>
            <p>
              <b>Số phòng: </b> {objDetailBds?.sophong} phòng
            </p>
            <p>
              <b>Số wc: </b> {objDetailBds?.sowc} wc
            </p>
            <p>
              <b>Thu nhập từ cho thuê (số tiền): </b>{' '}
              <b className="text-red-500"> {numberFormatTextShorten(objDetailBds?.giathue)}</b>
            </p>
            <p>
              <b>Giá bán (số tiền): </b> <b className="text-red-500"> {numberFormatTextShorten(objDetailBds?.gia)}</b>
            </p>
            <p>
              <b>Ảnh BDS: </b>
            </p>
            <div className="grid grid-cols-5 gap-2">
              {objDetailBds.anhto?.split(',').length > 0 &&
                objDetailBds.anhto?.split(',').map((imageSrc, i) => (
                  <figure className="relative w-full border border-amber-500 border-dashed p-1" key={i}>
                    <img src={`${API_URL}/imgshop?name=${imageSrc}`} alt="not fount" width={'100%'} />
                  </figure>
                ))}
            </div>

            <p>
              <b>Sổ, giấy tờ: </b>
            </p>
            <div className="grid grid-cols-5 gap-2">
              {objDetailBds.anhthua?.split(',').length > 0 &&
                objDetailBds.anhthua?.split(',').map((imageSrc, i) => (
                  <figure className="relative w-full border border-amber-500 border-dashed p-1" key={i}>
                    {typeImg(imageSrc) ? (
                      <img src={`${API_URL}/imgshop?name=${imageSrc}`} alt="not fount" width={'100%'} />
                    ) : (
                      <a href={`${API_URL}/imgshop?name=${imageSrc}`} download={imageSrc} width={'100%'}>
                        {'file_' + i + 1}
                      </a>
                    )}
                  </figure>
                ))}
            </div>
          </div>
        </DialogBody>
        <DialogFooter>
          <Button variant="text" color="red" onClick={handleOpen} className="mr-1">
            <span>Đóng</span>
          </Button>
        </DialogFooter>
      </Dialog>
      <Card className="w-full">
        <CardHeader floated={false} shadow={false} className="rounded-none">
          <div className="mb-8 flex items-center justify-between gap-8">
            <div>
              <div className="text-xl font-bold">DANH SÁCH BÀI VIẾT BĐS</div>
              {/* <Typography color="gray" className="mt-1 font-normal">
              Tất cả nhân viên đang hoạt động và đã nghỉ
            </Typography> */}
            </div>
            <div className="flex shrink-0 flex-col gap-2 sm:flex-row">
              {/* <Button variant="outlined" size="sm">
              view all
            </Button> */}
              <Link to="/addbds">
                <Button className="flex items-center gap-3 bg-green-600" size="sm">
                  <HomeModernIcon strokeWidth={2} className="h-4 w-4" /> Thêm BĐS Mới
                </Button>
              </Link>
            </div>
          </div>
          {isAdmin(auth) && (
            <div className="mb-3">
              <label className="mb-2 inline-block text-green-800 dark:text-neutral-400 font-bold">
                THÊM TIN BÀI VIẾT BẰNG FILE EXCEL
              </label>
              <input
                className="relative m-0 block min-w-0 flex-auto cursor-pointer rounded border border-solid border-gray-900 bg-transparent bg-clip-padding px-3 py-[0.32rem] text-base font-normal text-surface transition duration-300 ease-in-out file:-mx-3 file:-my-[0.32rem] file:me-3 file:cursor-pointer file:overflow-hidden file:rounded-none file:border-0 file:border-e file:border-solid file:border-inherit file:bg-transparent file:px-3  file:py-[0.32rem] file:text-surface focus:border-primary focus:text-gray-700 focus:shadow-inset focus:outline-none dark:border-white/70 dark:text-white  file:dark:text-white"
                type="file"
                onChange={(e) => handleFileUpload(e)}
              />
            </div>
          )}
          {message === 'Loading' && <b>Đang thêm dữ liệu....</b>}
          {message === 'Thành Công' && (
            <Alert
              icon={<BellAlertIcon className="h-5 w-5" />}
              className="rounded-none border-l-4 border-[#2ec946] bg-[#2ec946]/10 font-medium text-[#2ec946] flex items-center"
            >
              <b>THÊM TIN THÀNH CÔNG</b>
            </Alert>
          )}

          <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
            <Tabs value={''} className="w-full md:w-[40rem]">
              <TabsHeader>
                {TABS.map(({ label, value }) => (
                  <Tab
                    key={value}
                    value={value}
                    onClick={() => {
                      value === 4
                        ? listChoDuyetAll(1, 3)
                        : listUserAll(1, value, objBoLoc.username, decode(objBoLoc.code));
                      setObjBoLoc({ ...objBoLoc, stt: value });
                    }}
                  >
                    &nbsp;&nbsp;
                    {`${label}${
                      value === 3
                        ? `${countChoDuyet ? `(${countChoDuyet})` : ''}`
                        : value === 4
                        ? `${countBdsAll ? `(${countBdsAll})` : ''}`
                        : ''
                    }`}
                    &nbsp;&nbsp;
                  </Tab>
                ))}
                {auth?.username === 'admin' && (
                  <Tab
                    onClick={() => {
                      listUserAll(1, '4', objBoLoc.username, decode(objBoLoc.code));
                      setObjBoLoc({ ...objBoLoc, stt: '4' });
                    }}
                  >
                    &nbsp;&nbsp;
                    {`Thùng Rác`}
                    &nbsp;&nbsp;
                  </Tab>
                )}
              </TabsHeader>
            </Tabs>
            <div className="w-full md:w-96">
              <Input
                label="Tìm kiếm theo mã sản phẩm"
                value={objBoLoc?.code}
                icon={<MagnifyingGlassIcon className="h-5 w-5" />}
                onChange={(e) => setObjBoLoc({ ...objBoLoc, code: e.target.value })}
                onKeyPress={handleEnterKey}
              />
              <Typography variant="small" color="gray" className="mt-2 flex items-center gap-1 font-normal">
                <InformationCircleIcon className="h-4 w-4" />
                Nhập Mã Sản Phẩm tìm kiếm và sau đó ấn enter
              </Typography>
            </div>
          </div>
        </CardHeader>
        <CardBody className="overflow-auto px-0">
          <table className="mt-4 w-full min-w-max table-auto text-left">
            <thead>
              <tr>
                {TABLE_HEAD.map((head) => (
                  <th key={head} className="border-y border-blue-gray-100 bg-blue-gray-50/50 p-4">
                    <Typography variant="small" color="blue-gray" className="font-normal leading-none opacity-70">
                      {head}
                    </Typography>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {resultListBds.map((row, index) => {
                const isLast = index === resultListBds.length - 1;
                const classes = isLast ? 'p-4' : 'p-4 border-b border-blue-gray-50';

                return (
                  <tr key={index}>
                    <td className={classes}>
                      <div className="flex items-center gap-3">
                        <div className="flex flex-col">
                          <label className="font-normal text-base">
                            <b>{`${encode(row.id)}`}</b>
                          </label>
                        </div>
                      </div>
                    </td>
                    <td className={classes}>
                      <div className="flex flex-col w-72">
                        <label className="font-normal text-base">{`${row.loaibds ? row?.loaibds : ''}${
                          row.loaivitri ? ' - ' + row?.loaivitri : ''
                        }${row.phaply ? ' - ' + row?.phaply : ''}${
                          row.duong ? ' - đường ' + row?.duong + ', ' + row?.xa + ', ' + row?.huyen : ''
                        }${row.rongduong ? ', đường trước nhà ' + row?.rongduong + 'm' : ''}`}</label>
                        <label className="font-normal text-sm opacity-70">{row.tieude}</label>
                      </div>
                    </td>
                    <td className={classes}>
                      <div className="w-max">
                        <Chip
                          variant="ghost"
                          size="sm"
                          value={
                            row.status === '1'
                              ? 'Đang bán'
                              : row.status === '3'
                              ? 'Chờ duyệt'
                              : row.status === '4'
                              ? 'Đã Xoá'
                              : row.status === '5'
                              ? 'Ngưng Bán'
                              : row.status === '6'
                              ? 'Không hề bán'
                              : 'Đã bán'
                          }
                          color={
                            row.status === '1'
                              ? 'green'
                              : row.status === '3'
                              ? 'orange'
                              : row.status === '4'
                              ? 'blue-gray'
                              : 'blue-gray'
                          }
                        />
                      </div>
                    </td>

                    <td className={classes}>
                      <div className="flex flex-col">
                        <label className="font-normal text-sm ">{row?.update_date}</label>
                        <label className="font-normal text-sm opacity-70">{row?.create_date}</label>
                      </div>
                    </td>
                    <td className={classes}>
                      <div className="flex items-center">
                        {(isStatus === 3 || row.status === '4') && (
                          <Tooltip content="Sửa tin">
                            <Link to={`/addbds?u=${row.id}`}>
                              <IconButton variant="text">
                                <PencilIcon className="h-4 w-4" />
                              </IconButton>
                            </Link>
                          </Tooltip>
                        )}
                        <Tooltip content={`Xem chi tiết`}>
                          {row.status === '3' ? (
                            <IconButton
                              variant="text"
                              onClick={() => {
                                handleOpen();
                                setObjDetailBds(row);
                              }}
                            >
                              <EyeIcon className={`h-4 w-4 text-blue-600`} />
                            </IconButton>
                          ) : auth['wifi'] !== auth['lastiplogin'] &&
                            (Number(auth?.permission) === 2 || Number(auth?.permission) === 4) ? (
                            ''
                          ) : row.status !== '4' ? (
                            <Link to={`/bds/${encode(row.id)}`}>
                              <IconButton variant="text">
                                <EyeIcon className={`h-4 w-4 text-blue-600`} />
                              </IconButton>
                            </Link>
                          ) : (
                            ''
                          )}
                        </Tooltip>
                        {auth?.username === 'admin' && row.status !== '3' && row.status !== '4' && (
                          <Tooltip content={`Tích chọn nếu BĐS đã bán`}>
                            <Checkbox
                              // label="Đã bán"
                              onChange={(e) => {
                                alertRemoveUser(row.id, row.status);
                              }}
                              checked={row.status !== '1'}
                            />
                          </Tooltip>
                        )}
                        {auth?.username === 'admin' && row.status !== '4' && (
                          <Tooltip content={`Cho vào thùng rác`}>
                            <IconButton
                              variant="text"
                              onClick={(e) => {
                                alertRemoveBV(row.id);
                              }}
                            >
                              <TrashIcon className={`h-4 w-4 text-red-600`} />
                            </IconButton>
                          </Tooltip>
                        )}
                        {auth?.username === 'admin' && row.status === '4' && (
                          <Tooltip content={`Hoàn lại bài viết`}>
                            <IconButton
                              variant="filled"
                              onClick={(e) => {
                                alertNORemoveBV(row.id);
                              }}
                              size="sm"
                              color="green"
                            >
                              <ArrowUturnLeftIcon className={`h-4 w-4`} />
                            </IconButton>
                          </Tooltip>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </CardBody>
        {Math.ceil(countBds / 50) > page && (
          <CardFooter className="flex items-center justify-between border-t border-blue-gray-50 p-4">
            <Typography variant="small" color="blue-gray" className="font-normal">
              Page {page} of {Math.ceil(countBds / 50)}
            </Typography>
            <div className="flex gap-2">
              <Button variant="outlined" size="sm" onClick={prevPage}>
                Trang Trước
              </Button>
              <Button variant="outlined" size="sm" onClick={nextPage}>
                Trang Tiếp
              </Button>
            </div>
          </CardFooter>
        )}
      </Card>
    </div>
  );
}
